import gql from 'graphql-tag';
// eslint-disable-next-line import/no-cycle
import { spaceMemberGQLFields, } from './spaceMember.fields.js';
export function getSpaceMembersGQLQuery(fields) {
    return gql `
    query GetSpaceMembers(
      $after: String
      $before: String
      $limit: Int!
      $offset: Int
      $orderBy: SpaceMemberListOrderByEnum
      $reverse: Boolean
      $roleIds: [ID!]
      $spaceId: ID!
    ) {
      spaceMembers(
        after: $after
        before: $before
        limit: $limit
        offset: $offset
        orderBy: $orderBy
        reverse: $reverse
        roleIds: $roleIds
        spaceId: $spaceId
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            ${spaceMemberGQLFields(fields)}
          }
        }
      }
    }
  `;
}
export function addSpaceMemberGQLMutation(fields) {
    return gql `
    mutation AddSpaceMembers($input: [AddSpaceMemberInput!]!, $spaceId: ID!) {
      addSpaceMembers(input: $input, spaceId: $spaceId) {
        ${spaceMemberGQLFields(fields)}
      }
    }
  `;
}
export function removeSpaceMembersGQLMutation() {
    return gql `
    mutation RemoveSpaceMembers($memberIds: [ID!]!, $spaceId: ID!) {
      removeSpaceMembers(memberIds: $memberIds, spaceId: $spaceId) {
        status
      }
    }
  `;
}
export function getMemberSpacesGQLQuery(fields) {
    return gql `
    query GetMemberSpaces(
      $limit: Int!
      $after: String
      $memberId: ID!
      $collectionId: String
    ) {
      memberSpaces(
        limit: $limit
        after: $after
        memberId: $memberId
        collectionId: $collectionId
      ) {

        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            ${spaceMemberGQLFields(fields)}
          }
        }
      }
    }
  `;
}
//# sourceMappingURL=spaceMembers.gql.js.map